import React from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";

import { PlanRoutes } from "./Constants/routes";

const Plan = () => {
  const match = useRouteMatch();
  return (
    <>
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />
        {PlanRoutes.map(({ path, Component, exact, id }) => (
          <Route
            path={`${match.url}${path}`}
            exact={exact}
            component={Component}
            key={id}
          />
        ))}
        <Redirect to="/dashboard/plan" />
      </Switch>
    </>
  );
};

export default Plan;
